import { useQuery } from "@tanstack/react-query";
import { UseFormRegister, UseFormReturn } from "react-hook-form";

import brandCore from "../../core/brand.core";
import localeCore from "../../core/locale.core";
import ErrorCenterIcon from "../../icons/exclamationTriangleCenter.icon";
import LoadingOvalCenterIcon from "../../icons/loadingOvalCenter.icon";
import { selectCss } from "../reuseables/native.comp";

interface BrandProps {
  methods: UseFormReturn<{ brandId: string }, any>;
}

export default function ProductBrandSelector({ methods }: BrandProps) {
  return (
    <div id="brands-list">
      <BrandDetails register={methods.register} />
    </div>
  );
}

function useBrands() {
  return useQuery({
    queryKey: ["brands"],
    queryFn: () => brandCore.listBrands(1, 99999),
  });
}

interface BrandDetailsProps {
  register: UseFormRegister<{ brandId: string }>;
}

function BrandDetails({ register }: BrandDetailsProps) {
  const { data: brands, isLoading, error, isError } = useBrands();

  if (isError) return <ErrorCenterIcon reason={error.message} />;
  if (isLoading) return <LoadingOvalCenterIcon />;

  return (
    <div className="">
      <select className={`${selectCss} w-full max-w-64 text-xs h-[40px]`} {...register(`brandId`)}>
        <option></option>
        {brands!.items.map((brand) => (
          <option key={brand.id} value={brand.id}>
            {localeCore.getLocaleValueDefaultFallback(brand.name)}
          </option>
        ))}
      </select>
    </div>
  );
}
